import React, { useState, useEffect  } from "react";
import Editor from "react-simple-code-editor";
import Prism from "prismjs";
import beautify from "js-beautify";

import "prismjs/themes/prism.css";
import "prismjs/components/prism-javascript"; // Highlighting for JS-like Mongo syntax

const Mongo_Db_Query = ({mongo_query , setmongo_query_input}) => {
  const [code, setCode] = useState(
    mongo_query
  );

  useEffect(() => {
      setCode(mongo_query)
  }, [mongo_query])
  

  const formatQuery = (input) => {
    try {
      return beautify.js(input, {
        indent_size: 2,
        space_in_empty_paren: true,
      });
    } catch {
      return input; 
    }
  };

  const handleChange = (rawInput) => {
    const formatted = formatQuery(rawInput);
    setmongo_query_input(formatted)
    setCode(formatted);
  };
useEffect(() => {
    handleChange(code); 
  }, []);

  const highlight = (code) =>
    Prism.highlight(code, Prism.languages.javascript, "javascript");

  return (
    <div  className="mdq" style={{ }}>
      <Editor
        value={code}
        onValueChange={handleChange}
        highlight={highlight}
        padding={12}
        style={{
          fontFamily: '"Fira Code", monospace',
          fontSize: 14,
        //   backgroundColor: "#f7f7f7",
        //   border: "1px solid #ccc",
          borderRadius: 6,
          minHeight: "180px",
        }}
      />
    </div>
  );
};

export default Mongo_Db_Query;
